import { request } from '../../../global/services/request'

export async function getSubscriptions(partnerId: string, limit: number, page: number, sort: string) {
  if (!sort) {
    return await request({
      path: `/resellers/${partnerId}/subscriptions?limit=${limit}&page=${page}&include=stats,package`,
      method: 'GET'
    })
  } else {
    return await request({
      path: `/resellers/${partnerId}/subscriptions?limit=${limit}&page=${page}&include=stats,package&sort=${sort}`,
      method: 'GET'
    })
  }
}

export async function getSingleSubscription(partnerId: string, id: string) {
  return await request({
    path: `/resellers/${partnerId}/subscriptions/${id}?include=stats,package,renewal,allowance`,
    method: 'GET'
  })
}

export async function getSubscriptionDetails(id: string) {
  return await request({
    path: `/subscriptions/${id}?include=accounts,package,stats,accounts.latest_activity,accounts.stats,`,
    method: 'GET'
  })
}

export async function getFilteredSubscriptions(partnerId: string, filterId: string, limit: number, page: number, sort: string) {
  if (!sort) {
    return await request({
      path: `/resellers/${partnerId}/filters/subscriptions?reseller_filter_id=${filterId}&limit=${15}&page=${page}&include=package,stats`,
      method: 'GET'
    })
  } else {
    return await request({
      path: `/resellers/${partnerId}/filters/subscriptions?reseller_filter_id=${filterId}&limit=${15}&page=${page}&include=package,stats&sort=${sort}`,
      method: 'GET'
    })
  }
}

export async function getFilters(partnerId: string) {
  return await request({
    path: `/resellers/${partnerId}/filters/counts`,
    method: 'GET'
  })
}
